module.exports = __webpack_public_path__ + "static/salata-guel-4b7a8dcbbaae42b31e19045e40547a09.jpg";